/**
 * Mutates an object by deleting all properties that are `null` or `undefined`, including deeply nested properties.
 *
 * @param {object} obj
 * @returns
 */
export default function removeNull(obj) {
  Object.keys(obj).forEach(
    key =>
      (obj[key] && typeof obj[key] === 'object' && removeNull(obj[key])) ||
      ((obj[key] === undefined || obj[key] === null) && delete obj[key])
  );

  return obj;
}
